export const isEmoji = (emoji: string) =>
  /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/gu.test(emoji)
